import { ddmmyyyy } from '@/utils/date/date-to-string';
import { isToday } from '@/utils/date/is-today';
import { isTomorrow } from '@/utils/date/is-tomorrow';

export function useVerbalDate(date: string): string {
  let verbalDate = ddmmyyyy(new Date(date));

  if (isToday(new Date(date))) {
    verbalDate = 'сегодня';
  } else if (isTomorrow(new Date(date))) {
    verbalDate = 'завтра';
  }

  return verbalDate;
}
